/**
 * Accent-insensitive text helpers for search (e.g. Salmón ↔ Salmon, Asiática ↔ Asiatica).
 */
export function normalizeSearchText(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function includesSearch(haystack, needle) {
  const q = normalizeSearchText(needle);
  if (!q) return true;
  return normalizeSearchText(haystack).includes(q);
}

export function recipeMatchesSearch(recipe, searchTerm) {
  if (!searchTerm?.trim()) return true;
  const q = normalizeSearchText(searchTerm);
  if (normalizeSearchText(recipe?.nombre).includes(q)) return true;
  if (normalizeSearchText(recipe?.descripcion).includes(q)) return true;
  if (Array.isArray(recipe?.tags) && recipe.tags.some((t) => normalizeSearchText(t).includes(q))) {
    return true;
  }
  if (normalizeSearchText(recipe?.tagsDisplay).includes(q)) return true;
  return false;
}
